import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import client from './contentfulClient';

const CreativeDetails = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    client
      .getEntry(id)
      .then((entry) => {
        setProject(entry.fields);
      })
      .catch(console.error);
  }, [id]);

  if (!project) return <p>Loading...</p>;

  const { projectName, description, thumbnail, images } = project;

  return (
    <>
      <section className="creative_ballina">
        <div className="container">
          <h1>
            <span>
              <span style={{ color: 'rgb(0, 0, 0)', backgroundColor: 'rgb(255, 255, 255)' }}>
                {projectName}
              </span>
            </span>
          </h1>
          <div className="creative_description">
            <h2>{description}</h2>
          </div>
        </div>
      </section>

      <section className="creative_work">
        <div className="container">
          {/* Featured thumbnail image */}
       
          {/* Additional images from 'images' field */}
          {images && images.length > 0 && images.map((image, index) => (
            <div className="creative_image-wrapper" key={index}>
              <img
                src={`https:${image.fields.file.url}`}
                alt={image.fields.title || `Creative Image ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default CreativeDetails;
